import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { InfoOutlined } from "@material-ui/icons";
import PropTypes from "prop-types";

import { useStyles } from "./ToolTip.styles";

const ToolTip = ({ label, variant = "dark", placement }) => {
  const classes = useStyles();

  const tooltipClass =
    variant === "white" ? classes.tooltipWhite : classes.tooltip;
  const arrowClass = variant === "white" ? classes.arrowWhite : classes.arrow;
  return (
    <Tooltip
      arrow
      classes={{
        tooltip: tooltipClass,
        arrow: arrowClass,
      }}
      title={label}
      placement={placement}
    >
      <InfoOutlined></InfoOutlined>
    </Tooltip>
  );
};

ToolTip.defaultProps = {
  label: "",
};

ToolTip.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.string,
  placement: PropTypes.string,
};

export { ToolTip };
